export default class FileV2 {
  public id!: number;
  public name!: string;
  public internalName!: string;
  public size!: number;
  public url!: string;
  public extension!: string;
}
